import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import moment from "moment";
import api from "../api";
import "./attendanceCalendar.css"; // Create this for ✅/❌ styles

export default function AttendanceCalendarWithEdit({ studentEmail }) {
  const [attendanceMap, setAttendanceMap] = useState({}); // date => { status, _id }

  // ✅ Fetch attendance & format into a map
  useEffect(() => {
    const fetchAttendance = async () => {
      if (!studentEmail) return;
      try {
        const { data } = await api.get(
          `${process.env.REACT_APP_API_BASE_URL}attendance/student/${studentEmail}`
        );

        const map = {};
        data.forEach((entry) => {
          const date = moment(entry.date).format("YYYY-MM-DD");
          map[date] = { status: entry.status, id: entry._id };
        });
        setAttendanceMap(map);
      } catch (err) {
        console.error("Error fetching attendance", err);
      }
    };

    fetchAttendance();
  }, [studentEmail]);

  // ✅ Toggle Present/Absent
  const handleDateClick = async (dateObj) => {
    const date = moment(dateObj).format("YYYY-MM-DD");
    const record = attendanceMap[date];

    const newStatus = record?.status === "Present" ? "Absent" : "Present";

    try {
      if (record) {
        await api.put(`${process.env.REACT_APP_API_BASE_URL}attendance/update-status/${record.id}`, {
          status: newStatus,
        });
      } else {
        await api.post(`${process.env.REACT_APP_API_BASE_URL}attendance/manual-add`, {
          email: studentEmail,
          date,
          status: newStatus,
        });
      }

      // Re-fetch
      const { data } = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}attendance/student/${studentEmail}`
      );
      const updatedMap = {};
      data.forEach((entry) => {
        const formatted = moment(entry.date).format("YYYY-MM-DD");
        updatedMap[formatted] = { status: entry.status, id: entry._id };
      });
      setAttendanceMap(updatedMap);
    } catch (err) {
      console.error("Error updating attendance", err);
    }
  };

  // ✅ Mark Absent by default
  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;

    const formatted = moment(date).format("YYYY-MM-DD");
    const inRange = moment(formatted).isBetween("2025-05-14", "2025-09-16", null, '[]');
    if (!inRange) return null;

    const status = attendanceMap[formatted]?.status;

    if (status === "Present") return <div className="text-green-600 text-lg">✅</div>;
    if (status === "Absent") return <div className="text-red-600 text-lg">❌</div>;
    return <div className="text-red-400 text-lg">❌</div>; // Default to Absent
  };

  return (
    <div
  className="p-4 rounded-xl border backdrop-black-md"
  style={{
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.15)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
  }}
>
  <Calendar
    minDate={new Date("2025-05-15")}
    maxDate={new Date("2025-09-15")}
    tileContent={tileContent}
    onClickDay={handleDateClick}
  />
  <p className="mt-2 text-sm text-gray-600 text-center">
    Click a date to toggle ✅ / ❌
  </p>
</div>
  );
}